import React from 'react'
import CopyrightIcon from '@mui/icons-material/Copyright';
import "./footer.css"

const Footer = () => {
  return (
    <>
    <div className='footer' >
    <a href="https://github.com/VAmanjain" target="_blank">
    <CopyrightIcon className='icons'/>
                Aman Jain
              </a>
    </div>
    </>
    
  )
}

export default Footer